module.exports = __webpack_public_path__ + "img/assiant_2wm111.e558700c.jpg";